var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-container"},[_c('video',{ref:"videoPlayer",staticClass:"youtube-player",attrs:{"src":_vm.videoSource,"width":"600","height":"400","loop":"","muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }